import { warehouseTranslations } from "./warehouse/i18n";
import { knowledgeSpacesI18n } from "./knowledgeSpaces/i18n";
import { processMiningTranslations } from "./processMining/i18n";
import { baseTranslationsDe } from "./i18n/de";
import { baseTranslationsEn } from "./i18n/en";
import { SFWTranslations } from "./shopFloorWalk/i18n";

export default {
  de: {
    ...warehouseTranslations.de,
    ...processMiningTranslations.de,
    ...knowledgeSpacesI18n.de,
    ...SFWTranslations.de,
    ...baseTranslationsDe,
    "": "",
  },

  en: {
    ...warehouseTranslations.en,
    ...knowledgeSpacesI18n.en,
    ...processMiningTranslations.en,
    ...SFWTranslations.en,
    ...baseTranslationsEn,
    "": "",
  },
};

// Merge two message objects, the second one will override message from the first one
export function mergeMessages(messages1: object, messages2: object) {
  const result = {};
  [...new Set([...Object.keys(messages1), ...Object.keys(messages2)])].forEach(
    (langCode) =>
      (result[langCode] = {
        ...messages1[langCode],
        ...messages2[langCode],
      }),
  );
  return result;
}
